import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SimDistribution } from '@/features/dashboard/sim-distribution/SimDistribution';
import { usePageTitle } from '@/hooks/usePageTitle';

const simDistributionSearchSchema = z.object({
  deliveryRequestId: z.coerce.number().optional(),
});

export const Route = createFileRoute('/_dashboard/sim-distribution/')({
  component: SimDistributionPage,
  validateSearch: simDistributionSearchSchema,
});

function SimDistributionPage() {
  usePageTitle('SIM分配');
  return <SimDistribution />;
}
